import i18n, { type BackendModule, type ResourceKey } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { baseI18nConfig, normalizeLanguage, type AppLanguage } from './config';

type LocaleModule = { default: ResourceKey };

const localeLoaders: Record<AppLanguage, () => Promise<LocaleModule>> = {
    en: () => import('../locales/en.json'),
    de: () => import('../locales/de.json'),
    fr: () => import('../locales/fr.json'),
    es: () => import('../locales/es.json'),
    it: () => import('../locales/it.json'),
    pt: () => import('../locales/pt.json')
};

const lazyLocaleBackend: BackendModule = {
    type: 'backend',
    init: () => undefined,
    read(language, _namespace, callback) {
        localeLoaders[normalizeLanguage(language)]()
            .then((locale) => callback(null, locale.default))
            .catch((error: Error) => callback(error, null));
    }
};

function languageFromLocation(): AppLanguage {
    return normalizeLanguage(new URLSearchParams(window.location.search).get('lang'));
}

export const clientI18n = i18n.createInstance();

export const clientI18nReady = clientI18n
    .use(lazyLocaleBackend)
    .use(initReactI18next)
    .init({ ...baseI18nConfig, lng: languageFromLocation() });
